import React from "react";
import { useAuth } from "../../contexts/AuthContext";

export function BrandLogo() {
  const { effectiveAdvertiserName } = useAuth();
  return (
    <div style={{
      fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 14,
      color: "#151515",
      letterSpacing: "-0.2px",
      flexShrink: 0,
      userSelect: "none",
    }}>
      {effectiveAdvertiserName || "…"}
    </div>
  );
}
